import http from 'hub-http/clients/apiClient';

// These fields get nested and complicated. We should only type these if we really need to use them in the FE

export const getSubscriptionTypes = () => {
  return http.get('subscriptions/v1/definitions?includeInternal=true', {
    timeout: [30000],
    retries: 2
  });
};
export const getSubscriptionGroups = () => {
  return http.get('subscriptions/v1/preferences-group/all/with-permissions', {
    timeout: [30000],
    retries: 2
  });
};